module.exports = __webpack_public_path__ + "img/Approval.6536ac54.png";